import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=1015f4b5&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"
import style0 from "./Main.vue?vue&type=style&index=0&id=1015f4b5&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1015f4b5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1015f4b5')) {
      api.createRecord('1015f4b5', component.options)
    } else {
      api.reload('1015f4b5', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=1015f4b5&scoped=true", function () {
      api.rerender('1015f4b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scholarship/jornalPayment/Main.vue"
export default component.exports